import { QueryClient } from "@tanstack/react-query";
import { communityReviewSessionResponseSchema, type CommunityReviewSession } from "@squeek/module-contracts/community-review-v1";
import { AdminSessionStore } from "../session";
import { createReviewApi } from "./api";

export const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 10_000, refetchOnWindowFocus: true, retry: false }, mutations: { retry: false } } });
export const REVIEW_SESSION_KEY = "squeek.community.review.session";
let storage: Storage | null = null;
try { if (typeof window !== "undefined") storage = window.sessionStorage; } catch { /* Memory-only login if tab storage is blocked. */ }
export const reviewSession = new AdminSessionStore<CommunityReviewSession>(storage, () => queryClient.clear(), REVIEW_SESSION_KEY, communityReviewSessionResponseSchema, "review");
export const reviewApi = createReviewApi(import.meta.env.VITE_COMMUNITY_API_BASE_URL ?? "", { token: reviewSession.token, onAuthLoss: reviewSession.onAuthLoss });
